import Prefixer from 'inline-style-prefixer';
import { theme } from '@ublend-npm/aulaui-next';
import React from 'react';
import { SPACE_SELECTOR_HEIGHT } from '@app/constants/sizes';

interface PostStyles {
  container: React.CSSProperties;
  parentWrapper: React.CSSProperties;
  wrapper: React.CSSProperties;
  scheduledRow: React.CSSProperties;
  nextScheduledPost: React.CSSProperties;
  navigation: React.CSSProperties;
}

export const getPostStyles = (isFtEnabled: Boolean) => {
  const postContainerHeight = isFtEnabled
    ? '100%'
    : `calc(100vh - ${SPACE_SELECTOR_HEIGHT}px)`;

  // Transform your styles to work across different browsers
  const prefixer = new Prefixer();

  return prefixer.prefix<PostStyles>({
    container: {
      position: 'relative',
      overflow: 'hidden',
      height: postContainerHeight,
    },
    parentWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    wrapper: {
      position: 'relative',
      padding: '0 54px',
      width: '100%',
      height: 'calc(100% - 64px)',
      maxWidth: 624,
    },
    scheduledRow: {
      display: 'flex',
      flex: '1',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 40,
    },
    nextScheduledPost: {
      fontSize: '24px',
      lineHeight: '28px',
      fontWeight: 500,
      color: theme.color.text,
    },
    navigation: {
      padding: '20px 54px',
    },
  });
};
